import React from 'react'
import PropTypes from 'prop-types'

import Creation from './containers/Creation'

import './index.scss'

const CronScheduledStage = ({
  changeOpen,
  saveScheduledFormData,
  defaultScheduledData,
  isScheduledEditing,
  jobTypes
}) => {
  const onScheduledCreationSubmit = async (formData) => {
    saveScheduledFormData(formData)
  }

  return (
    <Creation
      changeOpen={changeOpen}
      onSubmit={onScheduledCreationSubmit}
      defaultScheduledData={defaultScheduledData}
      isScheduledEditing={isScheduledEditing}
      jobTypes={jobTypes}
    />
  )
}

CronScheduledStage.propTypes = {
  setStage: PropTypes.func,
  changeOpen: PropTypes.func,
  saveScheduledFormData: PropTypes.func
}

export default React.memo(CronScheduledStage)
